import styled from 'styled-components';
import Icon from '../Icon';

export const FilterDisplay = styled.div`
  position: relative;
  display: flex;
  height: 36px;
  width: 100%;
  background: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  border-radius: 3px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  padding: 9px 12px;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 6px;
  width: 218px;
`;

export const ArrowDownIcon = styled(Icon).attrs({
  icon: 'TR5-Dropdown'
})`
  width: 12px;
  height: 16px;
`;

export const SelectedOption = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props =>
    props.isAll
      ? props.theme.COLORS.NEUTRAL_20
      : props.theme.COLORS.BASE_INVERTED};
`;
